var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFq00(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.18,17.77l-6.1-.02v-6.37s6.1.02,6.1.02c.46,0,.83-.37.83-.82,0-.46-.37-.83-.82-.83l-6.09-.02v-4.41c0-.46-.36-.83-.81-.83-.46,0-.83.37-.83.82v13.27s-.02,5.25-.02,5.25c0,.46.37.83.82.83.46,0,.83-.37.83-.82v-4.44s6.1.02,6.1.02c.46,0,.83-.37.83-.82,0-.46-.37-.83-.82-.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.29,6.23c-5.74.27-10.34,3.51-10.85,7.59h-3.7c-1.04,0-2.69.6-3.06,1.94-.46,1.64,1.08,3.51,4.71,5.72,1.7,1.03,2.01,1.8,1.93,2.09-.08.3-.69.61-1.62.61-3.46-.02-5.96-.02-5.96-.02-.41,0-.75.34-.75.75s.34.75.75.75c0,0,2.5,0,5.96.02h.03c1.58,0,2.74-.65,3.04-1.7.24-.86,0-2.21-2.59-3.78-4.21-2.55-4.1-3.81-4.04-4.03.15-.52,1.13-.85,1.62-.85h3.7c.51,4.08,5.11,7.32,10.85,7.59.42.02.78-.33.78-.76V6.98c0-.42-.35-.78-.78-.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq00);
export default __webpack_public_path__ + "static/media/FQ00.6bc6f8d35165224e54f8645e97f9c655.svg";
export { ForwardRef as ReactComponent };